import { render, staticRenderFns } from "./c_home_custom_nav.vue?vue&type=template&id=c9c5e9da&scoped=true"
import script from "./c_home_custom_nav.vue?vue&type=script&lang=js"
export * from "./c_home_custom_nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c5e9da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9c5e9da')) {
      api.createRecord('c9c5e9da', component.options)
    } else {
      api.reload('c9c5e9da', component.options)
    }
    module.hot.accept("./c_home_custom_nav.vue?vue&type=template&id=c9c5e9da&scoped=true", function () {
      api.rerender('c9c5e9da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_custom_nav.vue"
export default component.exports